import Joi from "joi";

export const sendEmailOtpValidation = Joi.object({
  email: Joi.string()
    .required()
    .label("Email")
    .email({ tlds: { allow: false } })
    .messages({
      "string.empty": "{{#label}} is required",
    }),
});

export const sendMobileOtpValidation = Joi.object({
  countryCode: Joi.string().optional().label("Country Code").messages({
    "string.empty": "{{#label}} is required",
  }),
  mobile: Joi.number().required().label("Mobile Number").messages({
    "string.empty": "{{#label}} is required",
  }),
});

export const createProfileValidation = Joi.object({
  profile: Joi.object().optional().allow(null).label("Profile").messages({
    "string.empty": "{{#label}} is required",
  }),
  name: Joi.string().required().label("Name").messages({
    "string.empty": "{{#label}} is required",
  }),
  countryCode: Joi.string().optional().label("Country Code").messages({
    "string.empty": "{{#label}} is required",
  }),
  mobile: Joi.string().required().label("Mobile").messages({
    "string.empty": "{{#label}} is required",
  }),
  email: Joi.string()
    .required()
    .label("Email")
    .email({ tlds: { allow: false } })
    .messages({
      "string.empty": "{{#label}} is required",
    }),
  password: Joi.string()
    .pattern(
      new RegExp(
        "^(?=.*[A-Za-z])(?=.*\\d)(?=.*[@$!%*#?&])[A-Za-z\\d@$!%*#?&]{8,}$"
      )
    )
    .required()
    .label("Password")
    .messages({
      "string.pattern.base":
        "{{#label}} must be 8+ with A-Z, 0-9, and special characters.",
      "string.empty": "{{#label}} is required.",
    }),
  country: Joi.string().required().label("Country").messages({
    "string.empty": "{{#label}} is required",
  }),
  isEmailVerified: Joi.boolean().optional(),
  isMobileVerified: Joi.boolean().optional(),
});

export const updateProfileValidation = Joi.object({
  profile: Joi.string().optional().allow("").label("Profile").messages({
    "string.empty": "{{#label}} is required",
  }),
  name: Joi.string().required().label("Name").messages({
    "string.empty": "{{#label}} is required",
  }),
  dob: Joi.string().required().label("Date Of Group").messages({
    "string.empty": "{{#label}} is required",
  }),
  bloodGroup: Joi.string().required().label("Blood Group").messages({
    "string.empty": "{{#label}} is required",
  }),
  height: Joi.number().required().label("Height").messages({
    "string.empty": "{{#label}} is required",
  }),
  weight: Joi.number().required().label("Weight").messages({
    "string.empty": "{{#label}} is required",
  }),
  address: Joi.string().required().label("Address").messages({
    "string.empty": "{{#label}} is required",
  }),
  emergencyContact: Joi.string()
    .required()
    .label("Emergency Contact")
    .messages({
      "string.empty": "{{#label}} is required",
    }),
});

export const createProfileAdditionalDetailValidation = Joi.object({
  dob: Joi.string().required().label("Date Of Group").messages({
    "string.empty": "{{#label}} is required",
  }),
  bloodGroup: Joi.string().required().label("Blood Group").messages({
    "string.empty": "{{#label}} is required",
  }),
  height: Joi.string().required().label("Height").messages({
    "string.empty": "{{#label}} is required",
  }),
  weight: Joi.string().required().label("Weight").messages({
    "string.empty": "{{#label}} is required",
  }),
  address: Joi.string().required().label("Address").messages({
    "string.empty": "{{#label}} is required",
  }),
  emergencyContact: Joi.string()
    .required()
    .label("Emergency Contact")
    .messages({
      "string.empty": "{{#label}} is required",
    }),
});

export const loginValidation = Joi.object({
  email: Joi.string()
    .required()
    .label("Email")
    .email({ tlds: { allow: false } })
    .messages({
      "string.empty": "{{#label}} is required",
    }),
  password: Joi.string().required().label("Password").messages({
    "string.empty": "{{#label}} is required",
  }),
});

export const numberLoginValidation = Joi.object({
  countryCode: Joi.string().required().label("Country Code").messages({
    "string.empty": "{{#label}} is required",
  }),
  mobile: Joi.number().required().label("Mobile").messages({
    "string.empty": "{{#label}} is required",
  }),
  password: Joi.string().required().label("Password").messages({
    "string.empty": "{{#label}} is required",
  }),
});

export const resetPasswordValidation = Joi.object({
  newPassword: Joi.string()
    .pattern(
      new RegExp(
        "^(?=.*[A-Za-z])(?=.*\\d)(?=.*[@$!%*#?&])[A-Za-z\\d@$!%*#?&]{8,}$"
      )
    )
    .required()
    .label("New Password")
    .messages({
      "string.pattern.base":
        "{{#label}} must include at least one letter, one number, and one special character, and be at least 8 characters long.",
      "string.empty": "{{#label}} is required.",
    }),
  confirmPassword: Joi.string()
    .required()
    .valid(Joi.ref("newPassword"))
    .label("Confirm Password")
    .messages({
      "any.only": "{{#label}} must match password.",
      "string.empty": "{{#label}} is required.",
    }),
});
